const initialState = {
  map: {},
  custodians: [],
  updateError: null,
  loading: true,
};

export default function custodian(state = initialState, action) {
  switch (action.type) {
    case "CUSTODIAN_UPDATE_SUCCESS":
    case "LOAD_USER_APPLICATION_STATE_SUCCESS":
      const map = {};

      action.payload.custodians.forEach(function (custodian) {
        map[custodian.id] = custodian;
      });

      const custodians = Object.values(map).sort(function (a, b) {
        if (a.name > b.name) return 1;
        else if (a.name < b.name) return -1;
        else return 0;
      });

      return {
        ...state,
        loading: false,
        map,
        custodians,
        updateError: null,
      };
    case "CUSTODIAN_UPDATE_FAIL":
      return {
        ...state,
        loading: false,
        updateError: action.payload,
      };
    case "CUSTODIAN_UPDATE_REQUESTED":
      return {
        ...state,
        loading: true,
        updateError: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/custodian.reducer.js